"use client";

import useAnalyticsManager from "@/app/hooks/useAnalyticsManager";
import { useGetShoppingCartQuery } from "@/store/shoppingCartApi";
import { useGetUserQuery } from "@/store/userApi";
import { useEffect, useState } from "react";

const SearchPageAnalytics = () => {
  const { data: user } = useGetUserQuery();
  const { data: shoppingCart } = useGetShoppingCartQuery();
  const { dispatchPageView } = useAnalyticsManager();
  const [pageViewDispatched, setPageViewDispatched] = useState(false);

  useEffect(() => {
    if (pageViewDispatched === false && user && shoppingCart) {
      dispatchPageView({
        userState: user,
        shoppingCartState: shoppingCart,
      });
      setPageViewDispatched(true);
    }
  }, [dispatchPageView, pageViewDispatched, user, shoppingCart]);

  return null;
};

export default SearchPageAnalytics;
